import { memo } from 'react';

import { Menu, MenuItem } from '@mui/material';
import { useWallet } from '@solana/wallet-adapter-react';

import { WalletMultiButtonViewProps } from './types';

const CopyIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_3039_66887)">
      <path d="M2 13H3V14H14V15H13V16H1V15H0V4H1V3H2V13Z" fill="currentColor" />
      <path d="M15 1H16V12H15V13H4V12H3V1H4V0H15V1Z" fill="currentColor" />
    </g>
    <defs>
      <clipPath id="clip0_3039_66887">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
const LogoutIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M16 14V2H15V1H14V0H2V1H1V2H0V7H8V6H7V5H6V4H7H8V5H9V6H10V7H11V9H10V10H9V11H8V12H6V11H7V10H8V9H0V14H1V15H2V16H14V15H15V14H16Z"
      fill="currentColor"
    />
  </svg>
);
const DownIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M13 6.5H13.5V4.5H11.5V5H11V5.5H10.5V6H10V6.5H9.5V7H9V7.5H8.5V8H7.5V7.5H7V7H6.5V6.5H6V6H5.5V5.5H5V5H4.5V4.5H2.5V6.5H3V7H3.5V7.5H4V8H4.5V8.5H5V9H5.5V9.5H6V10H6.5V10.5H7V11H9V10.5H9.5V10H10V9.5H10.5V9H11V8.5H11.5V8H12V7.5H12.5V7H13V6.5Z"
      fill="currentColor"
    />
  </svg>
);

const UserIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M4.5 5.81818H3.8V2.90909H4.5V1.45455H5.2V0.727273H6.6V0H9.4V0.727273H10.8V1.45455H11.5V2.90909H12.2V5.81818H11.5V7.27273H10.8V8H9.4V8.72727H6.6V8H5.2V7.27273H4.5V5.81818ZM15 13.0909V15.2727H14.3V16H1.7V15.2727H1V13.0909H1.7V12.3636H2.4V11.6364H3.1V10.9091H4.5V10.1818H11.5V10.9091H12.9V11.6364H13.6V12.3636H14.3V13.0909H15Z"
      fill="currentColor"
    />
  </svg>
);
const View = ({
  walletInfo,
  balance,
  onClick,
  menuAnchorEl,
  menuItems,
  onMenuClose,
}: WalletMultiButtonViewProps) => {
  const { connected } = useWallet();
  return (
    <div className={'pr-[20px] py-[10px] md:pr-[24px] md:py-[12px]'}>
      <button className={'btn-reset font-ms_serif'} onClick={onClick}>
        {connected ? (
          <div className="flex flex-row items-center gap-[6px] text-[#f0e9d0b8] hover:text-[#f1c315] text-[14px] leading-[18px] md:gap-[8px] md:text-[16px] md:leading-[20px] md:tracking-[0.64px] md:px-[4px] md:ml-[-4px]">
            {walletInfo}
            <DownIcon />
          </div>
        ) : (
          <div className={'text-[#f0e9d0b8] hover:text-[#F1C315]'}>
            <div
              className={
                'flex flex-row gap-[8px] items-center text-center my-[-6px] ml-[-4px] pl-[4px] pr-[4px]'
              }
            >
              Login
              <UserIcon />
            </div>
          </div>
        )}
      </button>

      {Boolean(menuItems.length) && (
        <Menu
          open={Boolean(menuAnchorEl)}
          onClose={onMenuClose}
          anchorEl={menuAnchorEl}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          MenuListProps={{
            className: 'popup-pixel',
          }}
          classes={{ paper: 'bg-transparent' }}
        >
          {menuItems.map(
            ({ disabled, keepMenuOpenAfterClick, onClick, testId, text }) => (
              <MenuItem
                key={text}
                data-testid={`header-wallet-${testId}`}
                disabled={disabled}
                className="font-ms_serif text-[#f0e9cf] hover:text-[#F1C315] text-[16px] leading-[20px] flex flex-row items-center justify-between px-[12px] py-[8px] w-[180px]"
                onClick={() => {
                  onClick?.();
                  !keepMenuOpenAfterClick && onMenuClose?.();
                }}
              >
                {text}
                {text === 'Logout' ? <LogoutIcon /> : <CopyIcon />}
              </MenuItem>
            ),
          )}
        </Menu>
      )}
    </div>
  );
};

const memoView = memo(View);
memoView.displayName = 'ConnectWallet';
export default memoView;
